import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';

import {TestPageComponent} from './test-page.component';
import{TestpageRoutingModule} from './test-page-routing.module';

import { ModalModule, BsModalRef } from 'ngx-bootstrap/modal';

// Progress Component
import { ProgressbarModule } from 'ngx-bootstrap/progressbar';
import { TrailtestModule } from '../../trail-test/trail-test.module';


@NgModule({
    imports: [
        FormsModule,
        CommonModule,ModalModule.forRoot(),
        TestpageRoutingModule,
        ProgressbarModule.forRoot(),
        TrailtestModule
      ],
      declarations: [
        TestPageComponent
      ]

})
export class TestpageModule { }